import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import _ from 'lodash';
import { copyEvent } from 'gqlQueries/priceSimulator';
import { sendNotification } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useCopyScenarioEvent({ onComplete }: { onComplete: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);

    const [copyScenarioEvent] = useMutation(copyEvent, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { copyScenario } = payload;
            if (copyScenario?.scenarioId) {
                sendNotification('success', 'Scenario copied successfully');
                onComplete(copyScenario?.scenarioId);
            }
        } catch (error) {
            console.error(errorMessage, error);
            sendNotification('error', 'Scenario not copied. Please try again.');
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        copyScenarioEvent: (variables: any) => {
            setError(null);
            setLoading(true);
            copyScenarioEvent(variables);
        },
    };
}

export { useCopyScenarioEvent };
